import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { IMetadataImage } from "../../../interfaces/i-metadataimage";
import { ApiViewerService } from "../../../services/internal-services/api-viewer.service";
import { MapService } from "../../../services/internal-services/map.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-images-panel",
  templateUrl: "./images-panel.component.html",
  styleUrls: ["./images-panel.component.scss"],

  standalone: false,
})
export class ImagesPanelComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() closeEvent = new EventEmitter<boolean>();

  @Output() paintCoverageEvent = new EventEmitter<{
    wkt: any;
    id: string;
  }>();

  dataSource: MatTableDataSource<IMetadataImage>;

  expandedElement: IMetadataImage | null;

  _images: IMetadataImage[];

  displayedColumns: string[] = ["layername", "projectname", "orientation", "capture_date"];

  constructor(
    private apiViewerService: ApiViewerService,
    private mapService: MapService,
  ) {}

  @Input()
  set images(images: IMetadataImage[]) {
    this._images = images;
    if (this.dataSource) {
      this.dataSource.data = images;
    }
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this._images) {
      this.dataSource.data = this._images;
    }
  }

  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  paintImageFootprint(image: IMetadataImage) {
    this.paintCoverageEvent.emit({
      wkt: image.bbox_wkt_latlon,
      id: image.image_id,
    });
  }

  close() {
    this.closeEvent.emit(true);
  }

  downloadMetadata(image: IMetadataImage) {
    const element = document.createElement("a");
    element.setAttribute("href", `data:text/plain;charset=utf-8,${encodeURIComponent(JSON.stringify(image))}`);
    element.setAttribute("download", `${image.image_id}.json`);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
}
